import { gql } from "@apollo/client";

export interface IDeleteRecognitionResponse {
  deleteRecognition: {
    id: string;
    active: boolean;
  };
}

export interface IDeleteRecognitionVariables {
  id: string;
}

const DELETE_RECOGNITION = gql`
  mutation DeleteRecognition($id: String!) {
    deleteRecognition(id: $id) {
      id
      active
    }
  }
`;

export default {
  DELETE_RECOGNITION,
};
